import * as Sentry from '@sentry/browser';
import { Injectable } from '@angular/core';
import { IonicErrorHandler } from 'ionic-angular';

import { UserModel } from './../../models/user';
import { UserProvider } from './../user/user';

@Injectable()
export class ErrorReportingProvider {
  static readonly SENTRY_DSN =
    process.env.SENTRY_DSN ||
    'https://aea728c2696c4d08aa2d5c4800d5a299@sentry.io/5170091';
  static readonly SENTRY_RELEASE = process.env.SENTRY_RELEASE;
  ignoreErrorUrls: RegExp[] = [/https:\/\/maps\.googleapis\.com/];
  ignoreErrorMessages: string[] = ['Error Code: 401'];

  constructor(private userService: UserProvider) {}

  init() {
    Sentry.init({
      dsn: ErrorReportingProvider.SENTRY_DSN,
      release: ErrorReportingProvider.SENTRY_RELEASE,
      beforeSend: data => this.stripPathsFromData(data),
      blacklistUrls: this.ignoreErrorUrls,
      ignoreErrors: this.ignoreErrorMessages,
    });

    this.userService.currentUser$.subscribe(user => {
      this.setUserContext(user);
    });
  }

  private stripPathsFromData(data) {
    if (data.culprit) {
      data.culprit = data.culprit.substring(data.culprit.lastIndexOf('/'));
    }
    const stacktrace =
      data.stacktrace ||
      (data.exception && data.exception.values[0].stacktrace);
    if (stacktrace) {
      stacktrace.frames.forEach(function(frame) {
        frame.filename = frame.filename.substring(
          frame.filename.lastIndexOf('/')
        );
      });
      if (data.stacktrace) {
        data.stacktrace = stacktrace;
      } else {
        data.exception.values[0].stacktrace = stacktrace;
      }
    }
    return data;
  }

  private setUserContext(user: UserModel) {
    if (user) {
      Sentry.configureScope(scope => {
        scope.setUser({
          id: user.uid,
          email: user.email,
        });
      });
    } else {
      Sentry.configureScope(scope => scope.clear());
    }
  }
}

export class YoshiErrorHandler extends IonicErrorHandler {
  handleError(error) {
    super.handleError(error);
    try {
      Sentry.captureException(error.originalError || error);
    } catch (e) {
      console.error(e);
    }
  }
}



// WEBPACK FOOTER //
// ./src/providers/error-reporting/error-reporting.ts